import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-recover",
  "use": "icon-recover-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-recover\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n<path d=\"M15.35,14.63l.87,1.74-.23.19A6.15,6.15,0,0,1,12,18h0a5.89,5.89,0,0,1-6-5.74A5.56,5.56,0,0,1,7.08,9l.37-.5,2.07,4.16H7.9a3.9,3.9,0,0,0,2.55,3.25A4.28,4.28,0,0,0,15,15ZM12,6h0A6.15,6.15,0,0,0,8,7.44l-.23.19.87,1.74L9,9a4.28,4.28,0,0,1,4.53-.89,3.9,3.9,0,0,1,2.55,3.25H14.48l2.07,4.16.37-.5A5.52,5.52,0,0,0,18,11.74,5.89,5.89,0,0,0,12,6Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol